import type { TranslationDict } from './ja'

export const en: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'How to play',
  helpAria: 'How to play',
  settings: 'Settings',
  settingsAria: 'Settings',
  close: 'Close',
  closeAria: 'Close',
  player: 'Player',
  highscore: 'High Score',
  start: 'Start Game',
  staminaEmpty: 'Not enough stamina',
  ranking: 'Territory League',
  difficultyTitle: 'Choose difficulty',
  difficultyStart: 'Start with this difficulty',
  back: 'Back',
  today: 'Today',
  weekly: 'This Week',
  alltime: 'All-Time',
  loading: 'Loading...',
  noScores: 'No scores yet. Be the first territory champion!',
  loadFailed: 'Failed to load',
  you: 'You',
  youConstant: 'YOU',
  language: 'Language',
  languageNote: 'Supports 18 languages including Japanese.',
  bgm: 'BGM',
  se: 'Sound effects',
  soundEnableAria: 'Turn sound on',
  soundDisableAria: 'Turn sound off',
  adWatch: 'Watch ad to the end',
  adCancel: 'Not now',
  rankSuffix: '',
  earnedPoints: 'earned {score} pts',
  helpGoalTitle: '🎯 Goal',
  helpGoalText: 'Place pieces on the 9x9 board and expand connected territories. The higher score wins.',
  helpWinTitle: '🏆 Win conditions',
  helpWinFive: 'Make five in a row vertically, horizontally, or diagonally for an instant win',
  helpWinScore: 'If the board fills up, the higher score wins. There are no draws.',
  helpScoreTitle: '💯 Scoring',
  helpLineBonus: 'Line bonuses: score points for 3, 4, and 5-in-a-row lines',
  helpClusterBonus: 'Territory bonus: score more as your connected groups grow',
  helpKomi: 'Komi: the second player gets a +10% score handicap',
  helpControlsTitle: '🖱️ Controls',
  helpControlsText: 'On your turn, tap an empty cell to place a piece.',
  helpTipsTitle: '💡 Tips',
  helpTipHell: 'Try HELL when you want the toughest challenge',
  helpTipCluster: 'Do not only chase five in a row. Bigger connected groups also raise your score.',
  resultWinFive: '🎉 Five in a row! You win!',
  resultWinScore: '🎉 Score victory! You win!',
  resultLoseFive: '😿 CPU made five in a row!',
  resultLoseScore: '😿 Score loss. Try again!',
  resultDraw: '🤝 Draw',
  newHighscore: '🏆 New high score!',
  scoreNone: 'No score',
  clusterBonus: 'Cluster bonus',
  retry: 'Play again',
  titleBack: 'Title',
  scoreHintPlaceStone: 'Place a stone',
  best: 'Best',
  clusterUnit: 'cluster',
  lineCount: '{len} in a row x{count}',
  turnCount: 'Move {count} · {difficulty}',
  boardPlayerPiece: 'Your piece',
  boardCpuPiece: 'CPU piece',
  boardPlayerAlt: 'You',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'row {row}, column {col}',
  boardPlaceable: 'placeable',
  boardEmpty: 'empty cell',
  boardFlower: 'has flower',
  firstPlayerAlt: 'First player',
  playerFirst: 'You go first!',
  playerSecond: 'You go second (+{bonus}% komi)',
  cpuFirst: 'CPU goes first!',
  finalePlayerWin: 'You win!',
  finaleCpuWin: 'CPU wins!',
  finaleFive: 'Five in a row!',
  finaleTerritory: 'Territory battle!',
  winnerAlt: 'Winner',
  loadingBoot: 'Starting...',
  loadingConnect: 'Connecting...',
  loadingProfile: 'Loading profile...',
  loadingAssets: 'Loading assets...',
  loadingReady: 'Ready',
  reauthRequiredTitle: 'Login required',
  startupFailedTitle: 'Startup failed',
  reauthButton: 'Log in again',
  reloadButton: 'Reload',
  lineReloginButton: 'LINE login',
  reauthReason: 'Your login has expired. Please log in again.',
  errorReauth: 'Your login has expired. Please log in again.',
  errorForbidden: 'You do not have permission to use this game.',
  errorNotFound: 'Game data was not found.',
  errorRateLimited: 'The network is busy. Please wait and try again.',
  errorServer: 'Could not connect to the server. Please wait and reload.',
  errorCommunication: 'A communication error occurred. Please reload.',
  errorNetwork: 'Could not connect to the network. Check your connection and reload.',
  errorStartup: 'Startup failed. Please reload.',
  settingsTabGeneral: 'Settings',
  settingsTabAccount: 'Account',
  settingsTabInfo: 'Info',
  account: 'Account',
  linked: 'Linked',
  guest: 'Guest',
  loggedInWith: 'Logged in with {provider}',
  loggedIn: 'Logged in',
  playingAsGuest: 'You are currently playing as a guest.',
  appleLoginBusy: 'Logging in with Apple...',
  appleLogin: 'Log in with Apple',
  googleLoginBusy: 'Logging in with Google...',
  googleLogin: 'Log in with Google',
  logoutBusy: 'Logging out...',
  logout: 'Log out',
  logoutSuccess: 'Logged out',
  logoutFailed: 'Logout failed',
  appInfo: 'App information',
  appName: 'App name',
  version: 'Version',
  legalInfo: 'Legal',
  terms: 'Terms of Use',
  privacy: 'Privacy Policy',
  operator: 'Operator',
  contact: 'Contact',
  copyTap: 'Tap to copy',
  idCopied: 'ID copied',
  copyFailed: 'Copy failed',
  other: 'Other',
  reportAd: 'Report inappropriate ad',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Edit profile',
  displayName: 'Display name',
  displayNamePlaceholder: 'Enter a name',
  chooseIcon: 'Choose icon',
  iconLoadFailed: 'Failed to load icons.',
  saveFailed: 'Failed to save. Please try again.',
  noIcons: 'No icons are available.',
  save: 'Save',
  saving: 'Saving...',
  staminaAria: 'Stamina {stamina} / {max}',
  nextRecovery: 'Next recovery in {time}',
  adPlaying: 'Playing ad...',
  recoverFullAd: 'Watch ad to fully restore stamina',
  dailyBonusAria: 'Watch ad to the end for +5 stamina',
  dailyBonusAd: 'Watch ad for +5 stamina',
  legalLastUpdated: 'Last updated: {date}',
  privacyTitle: 'Privacy Policy',
  termsTitle: 'Terms of Use',
  adPlayingAria: 'Ad playing',
  adBadge: '▶ Ad',
  adRemaining: '{seconds}s remaining',
  adDevHint: 'Development test ad. In production, a real ad will play.',
  adRewardRequirement: 'Watch the ad to the end to receive this reward.',
  adRewardStaminaDetail: 'Reward: restore stamina to its maximum',
  adRewardDailyBonusDetail: "Reward: +{amount} stamina as today's once-a-day bonus",
  adRewardIncompleteNote: 'If you close it before the end, you will not receive the reward.',
  adSkipAria: 'Skip ad',
  adSkip: 'Skip ✕',
  adSkipAfter: 'Skip in {seconds}s',
  offlineMessage: 'Cannot connect to the server. Some features may be unavailable.',
  reconnecting: 'Reconnecting...',
  reconnect: 'Reconnect',
  signInTitle: 'Sign in',
  signInBusy: 'Signing in...',
  signInCancelNote: 'If you cancel sign-in, you can continue as a guest. Some features will be unavailable.',
  processing: 'Processing...',
  recoverConfirmTitle: 'Confirm data replacement',
  recoverConfirmMessage: 'Existing data is linked to this login. Continuing will replace the guest data on this device. Do you want to continue?',
  recoverConfirmContinue: 'Restore',
  recoverConfirmCancel: 'Cancel',
  unlinkConfirmTitle: 'Unlink account',
  unlinkConfirmMessage: 'If you unlink this provider, this device will return to guest play. Your Hub data remains available if you log in again with the same provider on another device.',
  unlinkConfirmContinue: 'Unlink',
  unlinkConfirmCancel: 'Cancel',
  deleteConfirmTitle: 'Confirm account deletion',
  deleteConfirmMessage: 'Deleting your account will remove high scores, login data, linked accounts, and invitations.\nThis action cannot be undone. Do you really want to delete it?',
  deleteConfirmContinue: 'Delete account',
  deleteConfirmCancel: 'Cancel',
  adNekoTitle: 'AD neko',
  matchmakingRemaining: '{seconds}s remaining',
  matchmakingTimeoutMessage: 'No opponent was found in time. Please try again.',
  difficultyEasyName: 'Casual',
  difficultyEasyDescription: 'The opponent is a little distracted',
  difficultyNormalName: 'Normal',
  difficultyNormalDescription: 'The opponent sometimes makes a mistake',
  difficultyHardName: 'Hard',
  difficultyHardDescription: 'The opponent sees more of the board',
  difficultyHellName: 'Extreme',
  difficultyHellDescription: 'The opponent is strong and reads ahead',
}
